// npm packages
import React, { useState } from 'react'


// components
import Icon from '../Icon'
import { twMerge } from 'tailwind-merge'


const InputWithLabel = (
    { label = "", iconName, value = "", className, name, type = "text", placeholder = "Enter your value", onChangeHandler, maxLength = 50 }) => {

    const [inputValue, setInputValue] = useState(value)

    const handleInput = (e) => {
        setInputValue(e.target.value)
        onChangeHandler(e.target.value)
    }

    return (
        <div className={twMerge("input-with-label relative w-full", className)}>
            <div className="flex flex-row items-center justify-center h-[48px] gap-3 pl-16 pr-12 border border-senate rounded-[4px]">
                {
                    iconName ?
                        <Icon type={iconName} height="24px" width="24px" color="#5F6368" /> : null
                }
                <input
                    type={type}
                    name={name}
                    className="text-16 text-coarse-wool block w-full px-0 h-full text-sm focus:outline-none focus:ring-0 placeholder:text-senate !placeholder:text-16 !placeholder:font-encode-sans !placeholder:font-normal"
                    maxLength={maxLength}
                    placeholder={placeholder}
                    onChange={handleInput}
                    value={inputValue}
                />
            </div>
            <label
                className="font-encode-sans bg-white absolute top-[15px] left-3 text-14 font-medium text-senate leading-20 tracking-[0.28px] duration-300 transform -translate-y-6 px-[4px]"
            >
                {label}
            </label>
        </div>
    )
}

export default InputWithLabel